import React from 'react';
import PropTypes from 'prop-types';
import { Link } from "react-router-dom"
import './rsbutton.css'
const RsAdNewV2 = ({to, onClick, className, iconClass, children}) => {
  return (
    <Link
      to={to}
      className={`btn-rs text-purple ${className}`}
      onClick={onClick}
    >
    <i className={`font-size-14 align-middle btn-i ${iconClass}`}></i> {children}
    </Link>
  );
};

RsAdNewV2.propTypes = {
to:PropTypes.string,
className: PropTypes.string,
iconClass:PropTypes.string,
onClick: PropTypes.func,
children: PropTypes.string,
};
RsAdNewV2.defaultProps = {
    to:'#',
    className: '',
     iconClass: 'bx bx-plus-medical',
    onClick: () => {},
  };
export default RsAdNewV2;
